// selectedPlanSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SelectedPlan {
  planName: string;
  officeId: string;
  [key: string]: any; // extend if needed
}

interface SelectedPlanState {
  selectedPlans: SelectedPlan[];
}

const initialState: SelectedPlanState = {
  selectedPlans: [],
};

const selectedPlanSlice = createSlice({
  name: "selectedPlans",
  initialState,
  reducers: {
    addPlan: (state, action: PayloadAction<SelectedPlan>) => {
      state.selectedPlans.push(action.payload);
    },
    removePlan: (state, action: PayloadAction<SelectedPlan>) => {
      state.selectedPlans = state.selectedPlans.filter(
        plan => plan.planName !== action.payload.planName || plan.officeId !== action.payload.officeId
      );
    },
    clearPlans: state => {
      state.selectedPlans = [];
    },
  },
});

export const { addPlan, removePlan, clearPlans } = selectedPlanSlice.actions;
export default selectedPlanSlice.reducer;
